import React from "react";
import { Button, Spinner } from "react-bootstrap";

interface SubmitButtonProps {
  isSubmitting: boolean;
  isEdit?: boolean;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  labels?: {
    create?: string;
    update?: string;
    submitting?: string;
    updating?: string;
  };
}

const SubmitButton: React.FC<SubmitButtonProps> = ({
  isSubmitting,
  isEdit,
  onClick,
  labels,
}) => {
  const {
    create = "Add",
    update = "Update",
    submitting = "Adding...",
    updating = "Updating...",
  } = labels || {};

  return (
    <Button
      type={onClick ? "button" : "submit"}
      variant="primary"
      disabled={isSubmitting}
      onClick={onClick}
      className="w-sm-auto py-2 px-3" // responsive width & padding
      // style={{ minWidth: 100 }}
    >
      {isSubmitting ? (
        <>
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
            // className="me-2 btn btn-primary"
          />
          {isEdit ? updating : submitting}
        </>
      ) : isEdit ? (
        update
      ) : (
        create
      )}
    </Button>
  );
};

export default SubmitButton;
